import styled from "styled-components";

export const Align = styled.div`
    width: 100%;
    display: flex;

    p + p {
        margin-left: 10px;
    }
`;
